import { jsx } from "react/jsx-runtime";
import { Box } from "../../Box/Box.mjs";
import { useIcon } from "../../../hooks/useIcon/index.mjs";
import { IconSendSvg } from "./IconSendSvg.mjs";
const IconSend = (props) => {
  const iconProps = useIcon(props);
  return /* @__PURE__ */ jsx(Box, { component: IconSendSvg, ...iconProps });
};
export {
  IconSend
};
